import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  template: `
     <form [formGroup]="formEdit" >
     <mat-dialog-content>
     <img src="/assets/wait2.gif" height="150px" />
      </mat-dialog-content>
    </form>
  `,
  styleUrls: ['./waiting-dialog.component.css']
})

export class WaitingDialogComponent implements OnInit {
  formEdit: FormGroup;
  constructor(private formBuilder: FormBuilder,
              private dialogRef: MatDialogRef<WaitingDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data) {
   }

  ngOnInit(): void {
    this.formEdit = this.formBuilder.group({});
  }
}



